export const theme = {
  colors: {
    darkblue: "#17224d",
    blue: "#3393f0",
    grey: "#7A7A7A",
    lightgrey: "#EDF1FC",
    white: "white",
  },
};
